import { _axios } from '@/plugins/axios';
import {
  ILoginRequest, ISignUpRequest, ILoginResponse, IUserProfile,
} from '@/shared/models';
import store from '@/store';

export default {
  async getUserProfile(token: string): Promise<IUserProfile> {
    try {
      store.commit('SET_HEADER', token);
      const profile = await _axios.get('user');
      return profile.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async login(data: ILoginRequest): Promise<ILoginResponse> {
    try {
      const res = await _axios.post('auth/signin', data);
      return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async signup(data: ISignUpRequest) {
    try {
      await _axios.post('auth/signup', data);
    } catch (err) {
      throw new Error(err);
    }
  },
};
